module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("Упс. Произошла ошибка скачивания файла")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc7776ec"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/errors/DownloadError.vue
// module id = 483
// module chunks = 42